export const guid = "b6242120-5bce-4b10-9839-d3045a7682da";
